module.exports = __webpack_public_path__ + "static/slicerSite-219fdc0b4b37e14d28acacfe2215b8d8.png";